import React, { ReactNode } from 'react'

interface IStringTitleProps {
  children?: ReactNode
}

export const StringTitle = (props: IStringTitleProps) => (
  <h1 className="header__ctr header__tit">{props.children}</h1>
)
